import { create } from 'zustand'

const useApp = create<{
	isLoading: boolean
	setIsLoading: (status: boolean) => void

	isContactOpen: boolean
	setIsContactOpen: (status: boolean) => void

	// isDarkMode: boolean
	// setIsDarkMode: (status: boolean) => void

	// isCartOpen: boolean
	// setIsCartOpen: (status: boolean) => void

	// cookieOptions: string
	// setCookieOptions: (status: string) => void

	// isTrackingEnabled: boolean
	// setIsTrackingEnabled: (status: boolean) => void

	// isCookieManagerOpen: boolean
	// setIsCookieManagerOpen: (status: boolean) => void

	// cart: any
	// setCart: (status: any) => void
}>((set) => ({
	isLoading: true,
	setIsLoading: (status) => {
		set((state) => ({
			...state,
			isLoading: status
		}))
	},

	isContactOpen: false,
	setIsContactOpen: (status) => {
		set((state) => ({
			...state,
			isContactOpen: status
		}))
	},

	// isDarkMode: true,
	// setIsDarkMode: (status) => {
	// 	set((state) => ({
	// 		...state,
	// 		isDarkMode: status
	// 	}))
	// },

	// isCartOpen: false,
	// setIsCartOpen: (status) => {
	// 	set((state) => ({
	// 		...state,
	// 		isCartOpen: status
	// 	}))
	// },

	// cart: null,
	// setCart: (status) => {
	// 	set((state) => ({
	// 		...state,
	// 		Cart: status
	// 	}))
	// },

	// cookieOptions: 'none',
	// setCookieOptions: (status) => {
	// 	set((state) => ({
	// 		...state,
	// 		cookieOptions: status
	// 	}))
	// },

	// isTrackingEnabled: false,
	// setIsTrackingEnabled: (status) => {
	// 	set((state) => ({
	// 		...state,
	// 		isTrackingEnabled: status
	// 	}))
	// },

	// isCookieManagerOpen: false,
	// setIsCookieManagerOpen: (status) => {
	// 	set((state) => ({
	// 		...state,
	// 		isCookieManagerOpen: status
	// 	}))
	// },
}))

export default useApp
